define('AAMedical.ScopeRepair.RigidScopeRepair.View'
,	[
		'aamedical_scoperepair_rigid.tpl',
		'Utils'
	]
,	function (
		aamedical_scoperepair_rigid_tpl,
		Utils
	)
{
	'use strict';

	return Backbone.View.extend({

		template: aamedical_scoperepair_rigid_tpl,

		title: Utils.translate('Rigid Scope Repair'),

		page_header: Utils.translate('Rigid Scope Repair'),

		attributes: {
			id: 'rigid-scope-repair',
			class: 'rigid-scope-repair-page'
		},

		getBreadcrumbPages: function() {
			return [{ href: '/rigid-scope-repair', text: Utils.translate('Rigid Scope Repair') }];
		},

		getContext: function() {
			return {};
		}
	});
});
